import {CartProduct} from './cart-product/CartProduct';
import {onDemandUnits, servedUnits} from '../domain/onDemandSplit';
import {groupPackLines, packParentName} from '../domain/packGrouping';
import type {Product} from '../models/Product';

interface Props {
  products: Product[],
  areDeprecated?: boolean,
  splitOnDemand?: boolean,
}

export const ProductListUI = ({ products = [], areDeprecated = false, splitOnDemand = false }: Props) => {
  // Con splitOnDemand, las líneas bypass enseñan aquí solo las unidades con stock;
  // el exceso (y las líneas enteramente sin stock) sale en la zona "Bajo pedido".
  const visible = splitOnDemand ? products.filter((product) => servedUnits(product) > 0) : products;
  // Los regalos de pack se pintan pegados a su producto padre.
  const ordered = groupPackLines(visible);
  return (
    <div className="d-flex flex-column gap-2">
      {
        products.length === 0 && (
          <div className="alert alert-light w-100">
            <span>No hay productos!</span>
          </div>
        )
      }
      {
        ordered?.map(product => (
          <CartProduct key={product.packOrigin ? `pack-${product.packParentId}-${product.id}` : product.id}
            product={product}
            isDeprecated={areDeprecated}
            packParentName={product.packOrigin ? packParentName(visible, product) : undefined}
            displayQuantity={splitOnDemand && onDemandUnits(product) > 0 ? servedUnits(product) : undefined}
          />
        ))
      }
    </div>
  );
};
